import Header from "../components/Header";
import Footer from "../components/Footer";
import { Outlet } from "react-router-dom";

const PublicLayout = ({ loginStatus }) => {
  return (
    <>
      <Header loginStatus={loginStatus} />
      <Outlet />
      <Footer />
    </>
  );
};

export default PublicLayout;
